import {
  Box,
  Card, CardContent, Grid, Tab, Tabs, Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  clearActivity, clearGroups, clearQuestion, clearQuestions, clearResponses, setAsQualified, setModalCloseActivity,
} from '../../activities/slice/activitySlice';
import { setExpirationDate } from '../../auth/slice/authSlice';
import useSetTitle from '../../shared/Hooks/useSetTitle';
import { getBook } from '../actions/booksActions';
import CardInfoBook from '../components/CardInfoBook';
import { oneYearLater } from '../helpers/oneYearLater';
import StudentUnitCard from '../subModule/units/components/StudentUnitCard';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel( props: TabPanelProps ) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps( index: number ) {
  return {
    id: `profile-tab-${index}`,
    'aria-controls': `profile-tabpanel-${index}`,
  };
}

const StudentsBookDetail = () => {
  const { book } = useAppSelector(( state ) => state.book );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const setTitle = useSetTitle({
    title: 'Leer Libro',
    subItems: ['Libros', 'Leer Libro', book?.name || ''],
    noPrintItems: false,
  });
  const [value, setValue] = useState( 0 );
  const handleChange = ( event: React.SyntheticEvent, newValue: number ) => {
    setValue( newValue );
  };
  const { activations } = useAppSelector(( state ) => state.auth );
  const theBookInActivations = [...activations]
    .sort(( a, b ) => b.created - a.created )
    .find(( activation ) => activation.bookId === book?.id );
  useEffect(() => {
    if ( !book ) {
      navigate( '/' );
    }
  }, [book, navigate, dispatch]);
  useEffect(() => {
    setTitle();
    dispatch( setExpirationDate( theBookInActivations?.created || new Date().getTime()));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setTitle]);
  useEffect(() => {
    dispatch( getBook( book?.id || '' ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    dispatch( clearQuestion());
    dispatch( clearQuestions());
    dispatch( clearActivity());
    dispatch( clearGroups());
    dispatch( setAsQualified( false ));
    dispatch( clearResponses());
    dispatch( setModalCloseActivity( false ));
  }, [dispatch]);

  if ( theBookInActivations && oneYearLater( theBookInActivations.created ) < new Date()) {
    return (
      <Card>
        <CardContent>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Typography variant="h6" color="textSecondary">
              Libro vencido, vuelve a comprarlo para continuar.
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }
  return (
    <>
      {book && (
        <Grid container spacing={4}>
          <Grid item xs={12} lg={3}>
            <CardInfoBook book={book} />
          </Grid>
          <Grid item xs={12} lg={9}>
            <Grid container>
              <Grid item xs={12}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="profile-tab"
                  textColor="primary"
                  indicatorColor="primary"
                >
                  <Tab label="Lectura" {...a11yProps( 0 )} />
                  <Tab label="Unidades & Actividades" {...a11yProps( 1 )} />
                </Tabs>
              </Grid>
              <Grid item xs={12}>
                <TabPanel value={value} index={0}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" fontWeight="bold">
                        Libro
                      </Typography>
                      <iframe
                        width="100%"
                        height="500px"
                        src={book.url}
                        title={book.name}
                        seamless={false}
                        // allowTransparency
                        allowFullScreen
                      />
                    </CardContent>
                  </Card>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <StudentUnitCard />
                </TabPanel>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default StudentsBookDetail;
